<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar class="nav-bar" :title="$t('提现记录')">
        <template #left>
          <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('数据为空') + '！'"/>
        <div v-for="(v,key) in list" v-else :key="key" class="item_list">
          <div class="topInfo">
            <span v-if="v.status === 2" style="color: #07c160">{{ v.status_text }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span>{{ $t('金额')}}：-{{ v.money }}</span>
          </div>
          <div class="desc">
            <span>{{ $t('说明')}}：{{ v.desc }}</span>
          </div>
          <div class="time">
            <span>{{ $t('提交时间')}}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t('审核时间')}}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("刷新成功") + '！');
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child {
  float: right;
}

.item_list .desc span {
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 下拉刷新PC端适配
  ::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  ::v-deep .van-loading__text {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  ::v-deep {
      .van-empty__image {
        width: 166px;
        height: 166px;
      }
      .van-empty__description {
        font-size: 16px;
      }
  }

  // 主内容区域PC端适配
  .container .main {
    padding: 0 6px; /* 10px * 0.5733 ≈ 6px */
  }

  // 列表项PC端适配
  .item_list {
    padding: 9px 9px; /* 15px * 0.5733 ≈ 9px */
    margin: 17px 6px; /* 30px * 0.5733 ≈ 17px, 10px * 0.5733 ≈ 6px */
    border-radius: 6px; /* 10px * 0.5733 ≈ 6px */
    line-height: 34px; /* 60px * 0.5733 ≈ 34px */
  }

  .item_list .topInfo span {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }

  .item_list .time span {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }

  .item_list .desc span {
    font-size: 14px; /* 25px * 0.5733 ≈ 14px */
  }
}
</style>
